<template>
  <b-navbar :style="{ background: config.navbarBackgroundColor }">
    <b-navbar-brand
      :style="{
        color: config.titleColor,
        fontSize: config.titleSize,
        whiteSpace: 'normal',
      }"
    >
      <b-row>
        <b-col cols="12" lg="1" class="text-center">
          <b-img fluid :src="config.logo" alt="logo" :style="logoStyle"></b-img>
        </b-col>
        <b-col
          cols="12"
          :lg="config.enableWCAG ? '7' : '11'"
          class="text-center mt-auto mb-auto d-flex title-text"
        >
          <span class="navbar-title">{{
            $locales.t("header.title", config.title)
          }}</span>
          <change-language
            v-if="!config.enableWCAG"
            class="ml-auto mt-auto mb-auto"
          ></change-language>

          <b-btn
            class="ml-1 mr-1"
            v-if="isLoggedIn && !config.enableWCAG"
            @click="logout"
            >Wyloguj</b-btn
          >
        </b-col>
        <b-col cols="12" lg="4" class="d-flex" v-if="config.enableWCAG">
          <div class="ml-auto mt-auto mb-auto wcag-buttons">
            <b-row style="text-align: center !important">
              <b-col cols="6">
                <span class="wcag-buttons-title">{{
                  $locales.t("header.font_size", "Rozmiar czcionki")
                }}</span>
              </b-col>
              <b-col cols="4">
                <span class="wcag-buttons-title">{{
                  $locales.t("header.contrast", "Kontrast")
                }}</span>
              </b-col>
              <b-col cols="2" v-if="config.enableSimplePage">
                <span class="wcag-buttons-title"></span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 2px">
              <b-col cols="6">
                <b-btn
                  class="zoom-button"
                  @click="unzoom"
                  aria-label="Powiększenie 100%"
                >
                  <span>x1.0</span>
                </b-btn>
                <b-btn
                  class="zoom-button"
                  @click="zoom2"
                  aria-label="Powiększenie 150%"
                >
                  <span>x1.5</span>
                </b-btn>
                <b-btn
                  class="zoom-button"
                  @click="zoom3"
                  aria-label="Powiększenie 200%"
                >
                  <span>x2.0</span>
                </b-btn>
              </b-col>
              <b-col cols="4">
                <b-btn
                  class="contrast-button no-contrast"
                  @click="noContrast"
                  aria-label="normalny kontrast"
                >
                  <span>A</span>
                </b-btn>
                <b-btn
                  class="contrast-button black-contrast"
                  @click="blackContrast"
                  aria-label="Duży kontrast"
                >
                  <span>A</span>
                </b-btn>
              </b-col>
              <b-col cols="2" v-if="config.enableSimplePage">
                <b-btn
                  aria-label="Wersja strony dla niedowidzących"
                  class="simple-page-button"
                  @click="goToSimplePage"
                >
                </b-btn>
              </b-col>
              <b-col>
                <change-language></change-language>
              </b-col>
              <b-col>
                <b-btn class="mr-0" v-if="isLoggedIn" @click="logout">Wyloguj</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
import ChangeLanguage from "../components/ChangeLanguage";
import {getCompanyNameFromConfig} from "@/utils/appSettings"
export default {
  name: "customNavbar",
  components: {
    ChangeLanguage,
  },
  computed: {
    config() {
      return this.$store.getters.layoutConfig;
    },
    companyName() {
      return this.$store.getters.getCompanyName;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    logoStyle(){
      if (!this.config){
        return {}
      }
      if (this.config.logoHeight == 0 || this.config.logoWidth == 0){
        return {}
      }
      
      return {
        height: this.config.logoHeight + 'px',
        width: this.config.logoWidth + 'px'
      }
    }
  },
  methods: {
    goToSimplePage(){
      const companyNameFromConfig = getCompanyNameFromConfig() 
      if (companyNameFromConfig)
      {
        this.$router.push({path:'/Reservation/Simple'})
      }else{
        this.$router.push({path:'/' + this.$store.getters.getCompanyName + '/Reservation/Simple'})
      }
    },
    logout() {
      sessionStorage.removeItem("token");
      this.$store.dispatch("logout");
      window.location.reload();
    },
    goToLogin() {
      this.$router.push({ path: "Login" });
    },
    noContrast() {
      this.$store.dispatch("setContrast", "none");
    },
    blackContrast() {
      this.$store.dispatch("setContrast", "black");
    },
    zoom2() {
      document.documentElement.style.fontSize = "27px";
      this.$store.dispatch("setBaseFontSize", "27px");
    },
    zoom3() {
      document.documentElement.style.fontSize = "36px";
      this.$store.dispatch("setBaseFontSize", "36px");
    },
    unzoom() {
      document.documentElement.style.fontSize = "18px";
      this.$store.dispatch("setBaseFontSize", "18px");
    },
  },
  mounted() {
    var fontSize = this.$store.getters.getBaseFontSize + "px";
    if (fontSize) {
      document.documentElement.style.fontSize = fontSize;
    }
  },
};
</script>

<style scoped>
.navbar {
  box-shadow: 0 0 15px black;
}
@media only screen and (min-width: 992px) {
  .text-center {
    text-align: left !important;
  }
}
@media only screen and (max-width: 992px) {
  img {
    max-height: 60px;
    max-width: 100%;
  }
}
.simple-page-button,
.contrast-button,
.zoom-button {
  margin: 0 8px;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  max-width: 2.5rem;
  max-height: 2.5rem;
  font-weight: bolder;
  font-size: 1rem;
  padding: 0;
  background-color: rgb(233, 233, 233);
  border: black 2px solid;
  color: black;
  box-shadow: 0 0 5px white;
}
.contrast-button span {
  font-size: 0.9rem;
}

.zoom-button span {
  font-size: 0.9rem;
}

.no-contrast {
  background: white;
  color: black;
  border-color: black;
  border: 2px black solid;
  box-shadow: 0 0 5px white;
}
.black-contrast {
  background: black;
  color: white;
  border-color: white;
  border: 2px white solid;
  box-shadow: 0 0 5px black;
}
.navbar {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.navbar-brand,
.col-1,
.row,
.col-lg-1 {
  padding: 0;
}
@media screen and (max-width: 992px) {
  .navbar-brand {
    width: 100%;
  }
  .wcag-buttons {
    margin-left: 0;
    margin-right: auto;
  }
  .title-text span {
    margin: auto;
  }
}
.wcag-buttons-title {
  font-size: 1rem;
}
.wcag-buttons {
  width: 100%;
}
.wcag-buttons .row,
.wcag-buttons .row > * {
  font-size: 1rem;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0;
  padding: 0;
  text-align: center;
}
.navbar-title {
  word-break: break-word;
}
.simple-page-button {
  background: url("~@/assets/obsluga_niewidomych.png");
  background-size: cover;
}
</style>


